import type { CreateShelfInput, RenameShelfInput, SetMessageShelvesInput } from '../../schemas/vaultShelf.js';
import type { VaultShelf, VaultShelvesSnapshot, Message } from '../../types/index.js';
import type { RequestFn } from '../http.js';

/** Vault shelves ("полки") — user-named, tag-style collections of saved items
 *  inside the personal Сейф. All routes are `me`-scoped; the server resolves the
 *  caller's vault channel and validates every message belongs to it. */
export function makeVaultShelvesApi(request: RequestFn) {
  return {
    listShelves: () => request<VaultShelvesSnapshot>('/api/me/vault/shelves'),
    createShelf: (input: CreateShelfInput) =>
      request<VaultShelf>('/api/me/vault/shelves', { method: 'POST', body: JSON.stringify(input) }),
    renameShelf: (id: string, input: RenameShelfInput) =>
      request<VaultShelf>(`/api/me/vault/shelves/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
    deleteShelf: (id: string) => request<void>(`/api/me/vault/shelves/${id}`, { method: 'DELETE' }),
    /** Messages filed under a shelf (shaped + visibility-checked server-side). */
    listShelfItems: (id: string) => request<{ messages: Message[] }>(`/api/me/vault/shelves/${id}/items`),
    /** Which shelves a given vault message is on (drives the toggle sheet). */
    getMessageShelves: (messageId: string) =>
      request<{ shelfIds: string[] }>(`/api/me/vault/messages/${messageId}/shelves`),
    /** Replace the full set of shelves a vault message is filed under. */
    setMessageShelves: (messageId: string, input: SetMessageShelvesInput) =>
      request<{ shelfIds: string[] }>(`/api/me/vault/messages/${messageId}/shelves`, {
        method: 'PUT',
        body: JSON.stringify(input),
      }),
  };
}
